import VueRouter from 'vue-router'
import {webAuth} from "@/plugins/globalVars";
import {isMobile} from "@/plugins/globalVars";

function mobileDashboard() {
	if(isMobile()) {
		return {
			nav: Dashboard,
			content: Dashboard,
		}
	}
	return {
		nav: DashboardMenu,
		content: Dashboard
	}
}

const Blog = () => import('./components/blog.vue')
const Guide = () => import('./components/guide.vue')
const Login = () => import('./components/login.vue')
const Dashboard = () => import('./components/dashboard.vue')
const Profile = () => import('./components/profile.vue')
const Premium = () => import('./components/premium.vue')
const About = () => import('./components/about.vue')
const CGU = () => import('./components/cgu.vue')
const CGV = () => import('./components/cgv.vue')
const landingPage = () => import('./components/landingpage.vue')
const Progression = () => import('./components/progression.vue')
const Error = () => import('./components/error-404.vue')
const Learn = () => import('./components/learn.vue')
const SeasonCard = () => import('./components/seasonCard.vue')
const DashboardMenu = () => import('./components/dashboardMenu.vue')
const SetGoal = () => import('./components/setgoal.vue')
const SelectNewShow = () => import('./components/selectNewShow')
const MyLevel = () => import('./components/my-level.vue')
const TestZone = () => import('./components/zoneTest.vue')

export const router = new VueRouter({
	base: '/',
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'landingPage',
			component: landingPage,
			/*
			children: [
				{
					path: '/guide/:step?',
					name: 'guide',
					component: Guide,
				},
				{
					path: '/login',
					name: 'login',
					component: Login,
					props: { connexionType: 1 }
				}
			]*/
		},
		{
			path: '*',
			name: 'landingPage',
			component: landingPage,
		},
		/*
		{
			path: '/learn/',
			name: 'learn',
			component: Learn,

			beforeEnter: (to, from, next) => {
				if(from.name === to.name) {
					next(false)
				}
				else if(to.name === 'learn') {
					next({name: 'saison'})
				}
				else {
					next()
				}
			},
			children: [
				{
					path: '/saison/',
					name: 'saison',
					components: {
						nav: Progression,
						content: SeasonCard
					},
				},
				{
					path: '/parcours',
					name: 'dashboard',
					components: mobileDashboard(),
					children: [
						{
							path: '/profile',
							name: 'profile',
							component: Profile,
						},
						{
							path: '/mon-niveau',
							name: 'english-level',
							component: MyLevel,
						},
						{
							path: '/catalogue',
							name: 'catalog',
							component: SelectNewShow,
						},
						{
							path: '/goal',
							name: 'goal',
							component: SetGoal,
						},
						{
							path: '/premium',
							name: 'premium',
							component: Premium,
						},
					]
				}
			]
		},
		{
			path: '/blog/:articleId?',
			name: 'blog',
			component: Blog,
		},
		{
			path: '/about',
			name: 'about',
			component: About,
		},
		{
			path: '/cgu',
			name: 'cgu',
			component: CGU,
		},
		{
			path: '/cgv',
			name: 'cgv',
			component: CGV,
		},
		{
			path: '/secret-zone',
			name: 'zoneTest',
			component: TestZone,
		},
		*/
	]
})
/*
export const router = new VueRouter({
	base: '/',
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
		},
		{
			path: '*',
			redirect: '/'
		},
		{

			path: '/season/:seasonId',
			props: false,
			name: 'season',
			component: Card,
		},
		{
			path: '/blog/:articleId?',
			props: false,
			name: 'blog',
			component: Blog,
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: Dashboard,

			beforeEnter: (to, from, next) => {
				if(from.name === to.name) {
					next(false)
				}
				else if(to.name === 'dashboard') {
					next({name: 'profile'})
				}
				else {
					next()
				}
			},

			children: [

				{
					path: 'profile',
					name: 'profile',
					component: Profile,
				},
				{
					path: 'premium',
					name: 'premium',
					component: Premium,
				},
			]
		},
		{
			path: '/about',
			name: 'about',
			component: About
		},
		{
			path: '/cgu',
			name: 'cgu',
			component: CGU
		},
	]
})
 */

/*
router.beforeEach((to, from, next) => {
	if(from.name === to.name && from.params.seasonId === to.params.seasonId) {
		next(false)
	}
	else {
		next()
	}
})*/

export default router;